// ---------------------------------------------------------------------------
// industry.content.ts — Per-industry translated content for industry landing
// pages. English text lives in seo-industry.data.ts; this file holds non-English
// locale overrides keyed by industry slug.
// ---------------------------------------------------------------------------
import type { SupportedLocale } from '../i18n.config';
import { INDUSTRY_AR } from './industry.ar';
import { INDUSTRY_TH } from './industry.th';
import { INDUSTRY_ES } from './industry.es';
import { INDUSTRY_FR } from './industry.fr';
import { INDUSTRY_DE } from './industry.de';
import { INDUSTRY_JA } from './industry.ja';
import { INDUSTRY_ZH } from './industry.zh';
import { INDUSTRY_HI } from './industry.hi';

export interface IndustryText {
  propertyType: string;
  heroTitle: string;
  heroSubtitle: string;
  painPoints: Array<{ title: string; description: string }>;
  solutionFeatures: Array<{ title: string; description: string; highlight?: string }>;
  caseStudy: { challenge: string; solution: string; results: string[] };
  statsLabels: string[];
  testimonial: { quote: string; role: string; hotel: string };
  faqItems: Array<{ question: string; answer: string }>;
  relatedIndustries: Array<{ label: string; description: string }>;
}

export const INDUSTRY_TRANSLATIONS: Partial<Record<SupportedLocale, Record<string, IndustryText>>> = {
  ar: INDUSTRY_AR,
  th: INDUSTRY_TH,
  es: INDUSTRY_ES,
  fr: INDUSTRY_FR,
  de: INDUSTRY_DE,
  ja: INDUSTRY_JA,
  zh: INDUSTRY_ZH,
  hi: INDUSTRY_HI,
};
